export default "__VITE_ASSET__DdrlTXGy__"